//import cookie from 'react-cookie';
import { Cookies } from 'react-cookie';
import { LocaleSetting } from '../../constants/Setting';
import { isString } from '../String/String';

/**
 * 日本語かどうか判定
 * @param {string} locale
 */
export function isJa(locale) {
  if (locale && locale === 'ja') {
    return true;
  }
  return false;
}

/**
 * 英語かどうか判定
 * @param {string} locale
 */
export function isEn(locale) {
  if (locale && locale === 'en') {
    return true;
  }
  return false;
}

/**
 * Localeを取得する関数
 * locationは通常Viewコンポーネントに渡ってくるので、それを渡すこと
 */
export function getLocale(location) {
  // cookie から取得
  const cookieLang = new Cookies().get('lang');

  // default
  const locale = location ?? cookieLang ?? LocaleSetting.DEFAULT_LANG;
  return locale;
}

/**
 * パスからデフォルトのロケールを取得
 * @param {*} pathname
 * @param {*} defaultValue
 */
export function getLocaleFromPathname(pathname, defaultValue) {
  if (isString(pathname)) {
    const locale = pathname.split('/')[1];
    return locale ? locale : defaultValue;
  }
  return defaultValue;
}

/**
 * YouTube 言語サポートの判定
 * zhとzh-CN以外はOK
 * @returns
 */
export function isSupportedLanguageForYouTube() {
  if (__CLIENT__) {
    const primaryLanguage = window.navigator.language.toUpperCase();
    return !(primaryLanguage === 'ZH' || primaryLanguage === 'ZH-CN');
  }
  return true;
}
